var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Family_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(14110 251)",
    stroke: "#24a81b",
    fill: "#24a81b",
    d: "M0 0h50v50H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".Family_svg__c{stroke:#24a81b;fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.125px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14110 -251)",
    clipPath: "url(#Family_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Family_svg__c",
    d: "M14147.66 273.962a2.253 2.253 0 103.187 0 2.253 2.253 0 00-3.187 0M14138.724 264.525a5.208 5.208 0 11-7.366 0 5.208 5.208 0 017.366 0M14144.416 288v-2.083a6.25 6.25 0 00-6.25-6.25h-6.25a6.25 6.25 0 00-6.25 6.25V288M14147.27 281.538h3.186c2.639 0 3.641 1.063 3.641 3.7v1.593M14122.436 273.962a2.253 2.253 0 11-3.187 0 2.253 2.253 0 013.187 0M14122.827 281.538h-3.186c-2.639 0-3.641 1.063-3.641 3.7v1.593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14110 251h50v50h-50z",
    fill: "none"
  }))));
}
export default SvgFamily;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Family.svg
// module id = 706
// module chunks = 13